<template>
  <div class="report--act-ttns-value check-list-phone auto-list_col_centered">
    <div class="value--weight">
      <div class="item">
        <span class="label">Вес погр: </span>{{ ttn.netto_ttn }} /
        {{ ttn.netto_fact }} / {{ ttn.netto_ttn - ttn.netto_fact }}
      </div>
      <div class="item">
        <span class="label">Вес выгр:</span> {{ ttn.bruto_ttn }} /
        {{ ttn.bruto_fact }} / {{ ttn.bruto_ttn - ttn.bruto_fact }}
      </div>
    </div>
    <act :response="response" :on-act-click="onActClick" :value="true" />
    <ttns :response="response" :on-t-t-n-click="onTTNClick" :value="true" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Act from '@/views/Report/Components/Responses/Columns/Act'
import Ttns from '@/views/Report/Components/Responses/Columns/Ttns'
export default {
  name: 'ActTtnsValue',
  components: {
    Act,
    Ttns,
  },
  props: {
    response: {
      type: Object,
      default: () => {},
    },
    onActClick: {
      type: Function,
      default: () => {},
    },
    onTTNClick: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters({
      getTtns: 'reports/getReportModal',
    }),
    ttn() {
      const ttns = this.getTtns(this.response.id, 'ttns')
      const weights = ttns.reduce(
        (acc, cur) => ({
          netto_ttn: Number(acc.netto_ttn + cur.netto_ttn),
          netto_fact: Number(acc.netto_fact + cur.netto_fact),
          bruto_ttn: Number(acc.netto_ttn + cur.netto_ttn),
          bruto_fact: Number(acc.netto_fact + cur.netto_fact),
        }),
        { netto_ttn: 0, netto_fact: 0, bruto_ttn: 0, bruto_fact: 0 },
      )

      return weights
    },
  },
}
</script>

<style lang="sass">
.report--act-ttns-value
  & .response-ttns, & .response-act
    font-weight: 300
    font-size: 12px
    &.danger, &.warning, &.success
      color: #303133
  & .value--weight
    font-size: 12px
    text-align: left
    & .label
      color: #A4A4A4
</style>
